/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Accordion from './Classes/Accordion';
import CountUpNumbers from './Classes/CountUpNumbers';
import ESGTable from "./Classes/ESGTable";
import Esg from "./Classes/Esg";
import FocusHandler from "./Classes/FocusHandler";
import Gri from "./Classes/Gri";
import Header from './Classes/Header';
import InteractiveLegend from './Classes/InteractiveLegend';
import InteractiveSVG from './Classes/InteractiveSVG';
import LazyLoad from "./Classes/Lazyload";
import MobileSliderHandler from "./Classes/MobileSliderHandler";
import ResponsiveTablesLight from "./Classes/ResponsiveTablesLight";
import Scrollspy from "./Classes/Scrollspy";
import SliderHandler from "./Classes/SliderHandler";
import Video from "./Classes/Video";
import VideoNative from "./Classes/VideoNative";
import Worldmap from "./Classes/Worldmap";
import YoutubeLinks from "./Classes/YoutubeLinks";

var lazyLoadInstance = null;

export default {
  version: () => {
    return NSContext.theme.version;
  },
};

// Initialize on document ready
document.addEventListener("DOMContentLoaded", function () {
  new Accordion({
    accordions: '.js-slide-toggler',
    pxCorrectionMobile: 110,
    pxCorrectionDesktop: -200,
    mobileBreakpoint: 1025
  });

  new CountUpNumbers({
    numbersSelector: '.lc-keyfigure__number',
    classIn: 'is-in-viewport',
    classOut: 'is-not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: ['.', '.'],
    thousandSepArray: [' ', ','],
  });

  new ESGTable();

  new Esg();

  new FocusHandler();

  new Gri();

  new Header();

  new InteractiveLegend();

  new InteractiveSVG();

  lazyLoadInstance = new LazyLoad();

  new MobileSliderHandler({
    outerWrapperSelector: '.lc-columns-slider',
    sliderPaginationselector: '.lc-columns-slider .swiper-pagination'
  });

  new ResponsiveTablesLight({
    tableComponentSelector: '.ns-table-wrap',
    tableContainerSelector: '.srl-table-container',
    tableSelector: '.ns-table-wrap table'
  });

  new Scrollspy();

  new SliderHandler({
    sliderType: 'articles',
    outerWrapperSelector: '.slider--article-tiles'
  });

  new SliderHandler({
    sliderType: 'header',
    outerWrapperSelector: '.slider--header'
  });

  new SliderHandler({
    sliderType: 'story',
    outerWrapperSelector: '.slider--story-tiles',
    sliderPaginationselector: '.slider--story-tiles .swiper-pagination'
  });

  new Video();

  new VideoNative();

  new Worldmap({
    idName: 'trigger-',
    className: 'lc-worldmap__popup--'
  });

  new YoutubeLinks();
});


